
import * as __star__ from 'prop-types';

const {
default: __default__,
array,
bool,
func,
number,
object,
string,
symbol,
any,
arrayOf,
element,
elementType,
instanceOf,
node,
objectOf,
oneOf,
oneOfType,
shape,
exact,
checkPropTypes,
resetWarningCache,
PropTypes
} = __star__;

export {
array,
bool,
func,
number,
object,
string,
symbol,
any,
arrayOf,
element,
elementType,
instanceOf,
node,
objectOf,
oneOf,
oneOfType,
shape,
exact,
checkPropTypes,
resetWarningCache,
PropTypes
};
export default __default__;
